webpackJsonp([125351562730620],{

/***/ 368:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---chinese-medicine-a0e39f21c11f6a62c5ab.js